import { translations_loaded } from '../../i18n';
import { FincredibleLogo, LoadingSpinner } from '../LoadingSpinner';
import { WithChildren } from '../../types/utility';
import useCustomization from '../../hooks/useCustomization';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { selectLanguage } from '../../app/slices/configuration.slice';
import { useAppSelector } from '../../app/hooks';
import { CustomizationKey } from '../../contexts/CustomizationsContext';

const FINCREDIBLE_XS2A_LOADING_TEXT_KEY: CustomizationKey = 'FINCREDIBLE_XS2A_LOADING_TEXT';

export const TranslationInitBoundary = ({ children }: WithChildren) => {
	const language = useAppSelector(selectLanguage);
	const i18n = useTranslation().i18n;

	useEffect(() => {
		i18n.changeLanguage(language);
	}, [i18n, language]);

	const title = useCustomization(FINCREDIBLE_XS2A_LOADING_TEXT_KEY);

	if (!translations_loaded) {
		return (
			<div style={{ justifyContent: 'center' }}>
				<LoadingSpinner title={title}>
					<FincredibleLogo />
				</LoadingSpinner>
			</div>
		);
	}

	return <>{children}</>;
};
